import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=04f35dba&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=04f35dba&prod&lang=scss"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=04f35dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f35dba",
  null
  
)

export default component.exports